import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from 'app/components'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { UsuarioList } from '../core/_models'
import { UsuariosColumns } from './columns/_columns'
import { useT } from '_metronic/i18n/Metronici18n'

export const UsuariosTable = () => {
  const { response, isLoading, isError, refetch } = useQueryResponse()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => UsuariosColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={
        filters.nome.trim()
          ? `Nenhum usuário encontrado para “${filters.nome.trim()}”`
          : 'Nenhum usuário nesta situação'
      }
      description='Revise o nome digitado ou a situação selecionada.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState title='Nenhum usuário para exibir' />
  )

  return (
    <CustomTable<UsuarioList>
      id='kt_table_usuarios'
      ariaLabel={t('usuario.plural')}
      itemLabel={{ singular: t('usuario.label.lowercase'), plural: t('usuario.plural.lowercase') }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
